import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('contacts'),
  rootKey: 'contact',
});



// WEBPACK FOOTER //
// ./app/models/contact.js